import React from 'react';
import {FormControl, FormGroup} from 'react-bootstrap';

export function ConservationActionPhaseFilter(props) {
    
    const onChange = (x) => {
        const { UpdateValue } = props;
        
        if (UpdateValue) {
            UpdateValue(x.target.value);
        }
    };
    
    const { Value, HideUnselectedOption, ConservationActionPhases } = props;
    const placeholder = "Phase Type";
    
    return <FormGroup controlId="formControlsSelect">
        <FormControl
            as="select"
            placeholder={placeholder}
            value={Value ? Value : ""}
            onChange={onChange}
        >
            {
                !HideUnselectedOption ?
                    <option value={""}>{placeholder}</option> :
                    null
            }
            {
                ConservationActionPhases.map((x, index) => {
                    return <option
                        key={index}
                        value={[x.conservationActionPhaseId, x?.confirmationStatusId].join(',')}
                    >
                        {x.name}
                    </option>;
                })
            }
        </FormControl>
    </FormGroup>
}


